import article from './articles.js'
import comment from './comment.js'
import media from './media.js'
export default {
  article,
  comment,
  media
}